import "../styles/theme.css";
import { createInertiaApp, router } from "@inertiajs/react";
import { createElement, type ComponentType } from "react";
import { createRoot } from "react-dom/client";
import { getCsrfToken, setCsrfToken } from "../lib/csrf";
import { adoptServerLanguage } from "../lib/i18n";

router.on("before", (event) => {
  const token = getCsrfToken();
  if (token) {
    event.detail.visit.headers["X-CSRF-Token"] = token;
  }
});

router.on("success", (event) => {
  const props = event.detail.page.props as { csrf_token?: string; locale?: string };
  setCsrfToken(props.csrf_token);
  if (adoptServerLanguage(props.locale)) {
    window.location.reload();
  }
});

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<{ default: ComponentType<unknown> }>("../pages/**/*.tsx", { eager: true });
    const page = pages[`../pages/${name}.tsx`];
    if (!page) throw new Error(`Missing Inertia page: ${name}`);
    return page;
  },
  setup({ el, App, props }) {
    adoptServerLanguage((props.initialPage.props as { locale?: string }).locale);
    createRoot(el).render(createElement(App, props));
  },
});
